// passive listener
jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ){
    this.addEventListener("touchstart", handle, { passive: true });
  }
};

// rolling start!
$(function() {
  if ('ontouchstart' in window || 'ontouch' in window) {
    $('body').addClass('touch');
  }

  // hamburger action
  $('.hamburger').on('click', function() {
    $(this).toggleClass('is-active');
    $('body').toggleClass('menu-active');
  });

  $('.main-navigation a').on('click', function(){
    $('.hamburger').removeClass('is-active');
    $('body').removeClass('menu-active');
  });

  $('.modal-trigger').on('click', function(e) {
    e.preventDefault();

    var targetModal = $(this).data('target'); // Assuming the trigger has a data-target attribute with the modal ID
    $('#' + targetModal).removeClass('is-hidden'); // Remove the class to hide the modal
    $('#' + targetModal).addClass('is-visible'); // Add a class to show the modal
    $('body').addClass('modal-open'); // Prevent body scroll
  });

  // Close modal when ESC key is pressed
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape') { // Check if the pressed key is ESC
      $('.modal.is-visible').each(function() {
        $(this).removeClass('is-visible'); // Remove the class to hide the modal
        $(this).addClass('is-hidden'); // Add the class to hide the modal
      });
      $('body').removeClass('modal-open'); // Allow body scroll
    }
  });


  // Optional: Close modal when clicking outside or on a close button
  $('.modal').on('click', function(e) {
    if ($(e.target).is('.modal') || $(e.target).is('.modal-close')) {
      $(this).removeClass('is-visible'); // Remove the class to hide the modal
      $(this).addClass('is-hidden'); // Add the class to hide the modal
      $('body').removeClass('modal-open');
    }
  });

  // $('.gallery').each(function() { // the containers for all your galleries
  //   $(this).magnificPopup({
  //     delegate: 'a', // the selector for gallery item
  //     type: 'image',
  //     gallery: {
  //       enabled: true,
  //       navigateByImgClick: true,
  //       preload: [0,1] // Will preload 0 - before current, and 1 after the current image
  //     },
  //     image: {
  //       tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
  //       /*titleSrc: function(item) {
  //         return item.el.attr('title') + '<small>by Marsel Van Oosten</small>';
  //       }*/
  //     }
  //   });
  // });

  // $('.modal-video').magnificPopup({
  //   type: 'iframe',
  //   mainClass: 'mfp-fade',
  //   removalDelay: 160,
  //   preloader: false,
  //   fixedContentPos: false
  // });

  // $('.play-trailer').magnificPopup({
  //   type: 'iframe',
  //   mainClass: 'mfp-fade',
  //   removalDelay: 160,
  //   preloader: false,
  //   fixedContentPos: false,

  //   callbacks: {
  //     open: function() {
  //       // Will fire when this exact popup is opened
  //       // this - is Magnific Popup object
  //       var vid = $('.screen-one').find('video');
  //       if (vid.length > 0) {
  //         $(vid)[0].pause();
  //       }
  //     },
  //     close: function() {
  //       // Will fire when popup is closed
  //       var vid = $('.screen-one').find('video');
  //       if (vid.length > 0) {
  //         $(vid)[0].play();
  //       }
  //     }
  //   }
  // });

});